import React from 'react';
import { Link } from 'react-router-dom';
interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}
interface CategoryListProps {
  categories: Category[];
}
const CategoryList = ({
  categories
}: CategoryListProps) => {
  return <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-63">
      {categories.map(category => <Link key={category.id} to={`/categories/${category.id}`} className="border border-gray-300 rounded-lg p-4 flex flex-col items-center" data-id="element-64">
          <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mb-2 border border-dashed border-gray-400" data-id="element-65">
            <span className="text-gray-500" data-id="element-66">{category.icon}</span>
          </div>
          <span className="font-medium text-center" data-id="element-67">{category.name}</span>
          <span className="text-xs text-gray-500" data-id="element-68">
            {category.count} communities
          </span>
        </Link>)}
    </div>;
};
export default CategoryList;